import { render, staticRenderFns } from "./WinnerList.vue?vue&type=template&id=142c0245&scoped=true&"
import script from "./WinnerList.vue?vue&type=script&lang=js&"
export * from "./WinnerList.vue?vue&type=script&lang=js&"
import style0 from "./WinnerList.vue?vue&type=style&index=0&id=142c0245&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142c0245",
  null
  
)

export default component.exports